import * as React from 'react';
import noop from 'lodash/noop';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { Link as RouterLink } from 'react-router-dom';
import { Box, BlockLink, Flex, Icon, Text, NakedButton } from 'roo-ui/components';

interface ActionItemProps {
  dataTestId?: string;
  icon: string;
  label: string;
  url?: string;
  external?: boolean;
  onClick: (event: React.MouseEvent<any>) => void;
  target?: string;
}

const ButtonLink = styled(NakedButton)`
  width: 100%;
  text-align: left;

  &:hover {
    ${Text}, ${Icon} {
      color: ${themeGet('colors.emperor')};
      transition-delay: 0.1s;
    }
  }
`;

const Link = styled(BlockLink)`
  &:hover {
    ${Text}, ${Icon} {
      color: ${themeGet('colors.emperor')};
      transition-delay: 0.1s;
    }
  }
`;

export const ActionItem: React.FC<ActionItemProps> = ({ dataTestId, icon, label, url, external = false, onClick = noop, target }) => {
  const content = (
    <Flex flexDirection="row" bg="white">
      <Icon name={icon} size={24} color="red" />
      <Text fontSize="16px" color="red" px={4}>
        {label}
      </Text>
    </Flex>
  );

  return (
    <Box>
      {!url ? (
        <ButtonLink onClick={onClick} data-testid={dataTestId}>
          {content}
        </ButtonLink>
      ) : (
        <Link as={external ? 'a' : RouterLink} to={url} href={url} onClick={onClick} data-testid={dataTestId} target={target}>
          {content}
        </Link>
      )}
    </Box>
  );
};
